<template>
  <v-app id="mainWrap">
    <topbar v-if="login" :swipDisplay="displayBackBtn" />
    <sidemenu v-if="login" />
    <v-main id="scroll-target" v-scroll.self="onScroll">
      <span id="floatAlert">
        <span v-if="advertisementNotifications.length">
          <AdvertisementBanner
            v-for="(advertisement, index) in advertisementNotifications"
            :key="index + '-1'"
            :activator="
              advertisementNotifications.length > 0 &&
              advertisement.dispatch.advertisement &&
              advertisement.dispatch.watched_at == null
            "
            :ad="advertisement"
            type="advertisement"
          />
        </span>
        <span v-if="systemNotifications.length">
          <AdvertisementModal
            v-for="(notification, index) in systemNotifications"
            :key="index + '-2'"
            :activator="
              notification.dispatch.advertisement.type != 'banner' &&
              notification.dispatch.watched_at == null &&
              systemNotifications.length > 0
            "
            :ad="notification"
            type="system"
          />
          <AdvertisementBanner
            v-for="(notification, index) in systemNotifications"
            :key="index + '-3'"
            :activator="
              notification.dispatch.advertisement.type == 'banner' &&
              notification.dispatch.watched_at == null &&
              systemNotifications.length > 0
            "
            :ad="notification"
            type="system"
          />
        </span>
        <span v-if="promotionNotifications.length">
          <AdvertisementModal
            v-for="(notification, index) in promotionNotifications"
            :key="index + '-4'"
            :activator="
              promotionNotifications.length > 0 &&
              notification.dispatch.watched_at == null
            "
            :ad="notification"
            type="promotion"
          />
        </span>
      </span>
      <NotsCount />
      <router-view v-if="showPages" />
      <loading v-else />
    </v-main>
    <Toaster />
    <NotificationAlerts />
    <ChangePassModal :activator="changePass" @close="closeModal" />
    <EmailConfirmationDialog :dialog="verifyEmail" @close="closeEmailModal" />
    <NotificationsToConfirm />
    <!-- <ChangePassModal :activator="changePass" @close="closeModal" /> -->
    <PushNotificationsDialog v-if="login" />
  </v-app>
</template>

<script>
import ChangePassModal from "@/components/general/ChangePassModal.vue";
import EmailConfirmationDialog from "@/views/forms/emailConfirmationDialog.vue";
import NotsCount from "@/components/general/NotsCount.vue";
import NotificationsToConfirm from "@/components/general/NotificationsToConfirm.vue";
import Sidemenu from "@/components/app_parts/sidemenu.vue";
import Topbar from "@/components/app_parts/topbar.vue";
import lang from "./helpers/lang";
import socketMixin from "@/mixins/socketMixin";
import clientDeviceMixin from "@/mixins/clientDeviceMixin";
import auth from "@/helpers/auth";
import Toaster from "@/components/app_parts/Toaster.vue";
import NotificationAlerts from "@/components/app_parts/NotificationAlerts.vue";
import PushNotificationsDialog from "@/components/tools/PushNotificationsDialog.vue";
import loading from "./components/tools/loading.vue";
import AdvertisementBanner from "@/components/general/AdvertisementBanner.vue";
import AdvertisementModal from "@/components/general/AdvertisementModal.vue";
import axios from "@/plugins/axios";
export default {
  name: "App",
  components: {
    Topbar,
    Sidemenu,
    Toaster,
    NotificationAlerts,
    PushNotificationsDialog,
    loading,
    ChangePassModal,
    NotificationsToConfirm,
    AdvertisementBanner,
    AdvertisementModal,
    NotsCount,
    EmailConfirmationDialog,
  },
  mixins: [socketMixin, clientDeviceMixin],
  data() {
    return {
      initiated: false,
      notsDialog: false,

      intervals: {},
      pulled: 0,
      scrollInterval: null,
      advertisements: null,
      scrollY: 0,
      lastScrollTop: 0,
      loadingIcon: "mdi-reload",
      displayBackBtn: true,
      changePass: false,
      verifyEmail: false,
      scroll: 0,
      topConfig: {
        pullText: this.$t("pullTo"),
        triggerText: this.$t("releaseTo"),
        loadingText: this.$t("refresh"),
        failText: this.$t("refreshFail"),
        triggerDistance: 95,
      },
    };
  },
  computed: {
    showPages() {
      const token = this.token;
      const checked = this.checked;
      const loadingDevices = this.loadingDevices;
      return (token && checked && !loadingDevices) || !token;
    },
    login() {
      return this.$store.getters["user/valid"];
    },
    token() {
      return this.$store.getters["user/token"];
    },
    checked() {
      return this.$store.getters["user/checked"];
    },
    loadingDevices() {
      return this.$store.getters["devices/loading"];
    },
    advertisementNotifications() {
      return JSON.parse(
        JSON.stringify(
          this.$store.getters["notificationAdvertisements/notifications"]
        )
      );
    },
    systemNotifications() {
      return JSON.parse(
        JSON.stringify(
          this.$store.getters["systemAdvertisements/notifications"]
        )
      );
    },
    promotionNotifications() {
      return JSON.parse(
        JSON.stringify(
          this.$store.getters["promotionAdvertisements/notifications"]
        )
      );
    },
  },
  watch: {
    login(v) {
      if (v) {
        this.setHasTopBarClass();
        this.initiate();
        this.inGroup();
      } else {
        this.removeHasTopBarClass();
      }
    },
    scrollY() {
      if (this.scrollY < 40) {
        this.displayBackBtn = true;
      }
      this.onScroll();
    },
    $route() {
      if (this.inGroup()) {
        localStorage.setItem("inGroup", true);
      } else {
        localStorage.setItem("inGroup", false);
      }
    },
  },
  async created() {
    this.fixLocale();
    if (this.token) {
      await this.$store.dispatch("user/get");
      if (!this.login) {
        this.logOut();
      } else {
        this.initiate();
      }
    } else {
      localStorage.removeItem("inGroup");
      localStorage.removeItem("mydata");
      localStorage.removeItem("mydataview");
    }
    this.isCustomApp();
  },
  mounted() {
    if (this.$vuetify.breakpoint.smAndDown) {
      this.scrollInterval = setInterval(() => {
        this.scrollY = window.scrollY;
      }, 100);
    }
    let darkmode = localStorage.getItem("dark");
    darkmode && darkmode == "1"
      ? (this.$vuetify.theme.dark = true)
      : (this.$vuetify.theme.dark = false);
    this.fixLocale();
    if (this.login) {
      this.setHasTopBarClass();
    } else {
      this.removeHasTopBarClass();
    }
    // console.log(this.advertisementNotifications);
  },
  destroyed() {
    for (const interval in this.intervals) {
      clearInterval(this.intervals[interval]);
    }
    this.intervals = {};
    clearInterval(this.scrollInterval);
  },
  methods: {
    closeModal() {
      this.changePass = false;
    },
    closeEmailModal() {
      this.verifyEmail = false;
    },
    inGroup() {
      let inGroup = !!this.$route.params.gslug;
      if (inGroup) {
        localStorage.setItem("inGroup", true);
      }
      localStorage.setItem("inGroup", false);
      return inGroup;
    },
    onScroll() {
      if (this.$vuetify.breakpoint.smAndDown) {
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > this.lastScrollTop) {
          this.displayBackBtn = false;
          this.lastScrollTop = st <= 0 ? 0 : st;
        } else if (
          window.innerHeight + window.scrollY >=
          document.body.offsetHeight
        ) {
          this.displayBackBtn = false;
          this.lastScrollTop = st <= 0 ? 0 : st;
        } else {
          this.displayBackBtn = true;
          this.lastScrollTop = st <= 0 ? 0 : st;
        }
        if (
          window.innerHeight + window.scrollY <= document.body.offsetHeight ==
            false &&
          window.scrollY < 30
        ) {
          this.displayBackBtn = true;
          this.lastScrollTop = st <= 0 ? 0 : st;
        }
      }
    },
    isCustomApp() {
      axios
        .get("/app")
        .then((res) => {
          document.title = res.data.data.title;
          if (res.data.data.custom) {
            localStorage.setItem("customApp", true);
          }
          this.$store.dispatch("general/setCustomApp", res.data.data.custom);
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    stateChange(state) {
      if (state === "pull") {
        this.loadingIcon = "mdi-reload mdi-24px";
      } else {
        this.loadingIcon = "mdi-reload mdi-spin mdi-24px";
      }
    },
    async initiate() {
      if (!this.initiated) {
        this.$store.dispatch("devices/fetchDevices");
        this.$store.dispatch("groups/getGroups");
        this.$store.dispatch("business/get");
        this.$store.dispatch("gateways/getGateways");
        this.$store.dispatch("devices/getGatewaysNames");
        this.$store.dispatch("automations/getAutomations");
        this.$store.dispatch("notificationAdvertisements/getNotifications");
        this.$store.dispatch("systemAdvertisements/getNotifications");
        this.$store.dispatch("promotionAdvertisements/getNotifications");
        let user = this.$store.getters["user/user"];
        let notifications = this.$store.getters["user/notifications"];
        this.checkNotificationConfirmations();
        let changePass = user.new_password_required;
        let first_login = localStorage.getItem("first_login");
        if ((first_login && first_login == "12345678") || changePass) {
          this.changePass = 1;
        }
        if (
          (!user.email_confirmed || user.email_confirmed == false) &&
          notifications.email
        ) {
          this.verifyEmail = true;
        }

        // else if (changePass) {
        // localStorage.removeItem("first_login");
        // }
        this.setIntervals();
        await sleep(2000);
        this.generalIntervals();
        this.initiated = true;
      }
    },
    async generalIntervals() {
      setInterval(async () => {
        this.$store.dispatch("devices/fetchDevices");
        this.$store.dispatch("groups/getGroups");
        this.$store.dispatch("business/get");
        this.$store.dispatch("devices/getGatewaysNames");
        this.$store.dispatch("automations/getAutomations");
        this.$store.dispatch("notificationAdvertisements/getNotifications");
        this.$store.dispatch("systemAdvertisements/getNotifications");
        this.$store.dispatch("promotionAdvertisements/getNotifications");
      }, 1000 * 60 * 5);
    },
    async setIntervals() {
      setInterval(() => {
        this.$store.dispatch("devices/reanalyzeDevices");
      }, 10000);
      setInterval(() => {
        // console.log("run");
        this.$store.dispatch("notificationAdvertisements/getNotifications");
        this.$store.dispatch("systemAdvertisements/getNotifications");
        this.$store.dispatch("promotionAdvertisements/getNotifications");
      }, 1000 * 60 * 30);
    },
    fixLocale() {
      this.$i18n.locale = lang.get();
    },
    setHasTopBarClass() {
      document.getElementById("body").classList.add("has-topbar");
    },
    removeHasTopBarClass() {
      document.getElementById("body").classList.remove("has-topbar");
    },
    logOut() {
      localStorage.removeItem("mydata");
      localStorage.removeItem("mydataview");
      localStorage.removeItem("customApp");
      auth.logout();
      this.$router.push("/login");
    },
    async checkNotificationConfirmations() {
      await this.$store.dispatch("notifications/fetchNotificationsToConfirm");
    },
  },
};
function sleep(ms) {
  // const selection = window.getSelection();

  // console.log("dasdasdasd", selection.rangeCount > 0 && !selection.isCollapsed);
  return new Promise((resolve) => setTimeout(resolve, ms));
}
</script>
